<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="iconName"
    fill="none"
  >
    <slot />
  </svg>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'

@Options({
  props: {
    iconName: {
      type: String,
      default: 'icon',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    viewBoxWidth: {
      type: [Number, String],
    },
    viewBoxHeight: {
      type: [Number, String],
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  name: 'svgPage',
})
export default class SvgBase extends Vue {
  get viewBox() {
    const width = this.viewBoxWidth ? this.viewBoxWidth : this.width
    const height = this.viewBoxHeight ? this.viewBoxHeight : this.height
    return `0 0 ${width} ${height}`
  }
}
</script>
